import PropTypes from 'prop-types';
import { getSessionStorage } from '@app/utils';
import { memo, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  LEGAL_PRIVACY_PAGE,
  STICKY_TIMEOUT
} from '@app/constants/commonConstants';
import { getTemplate } from './templates';

const TemplateManager = ({ layoutData, espotData, getEspotContent }) => {
  const { hash } = useLocation();
  const { widgetDefinitionIdentifier: templateId, childWidget = [] } =
    layoutData;

  const sortedWidgets = [...childWidget].sort(
    (a, b) => a.widgetSequence - b.widgetSequence
  );

  const legalPrivacyPageStorage = getSessionStorage(LEGAL_PRIVACY_PAGE);

  useEffect(() => {
    const LegalNotices = document.getElementById(hash.substring(1));
    if (LegalNotices) {
      const stickyHeaderHeight = document
        ?.getElementById('react-root-header')
        ?.getBoundingClientRect()?.height;

      if (window?.scrollY) {
        setTimeout(() => {
          window.scroll({
            behavior: 'smooth',
            left: 0,
            top: window?.scrollY - stickyHeaderHeight
          });
        }, STICKY_TIMEOUT);
      }
    }
  }, [hash, legalPrivacyPageStorage]);

  return (
    <div className="container" data-testid="templateContainer">
      {getTemplate(templateId, {
        widgets: sortedWidgets,
        espotData: espotData,
        getEspotContent: getEspotContent
      })}
    </div>
  );
};

TemplateManager.propTypes = {
  layoutData: PropTypes.shape({
    widgetDefinitionIdentifier: PropTypes.string.isRequired,
    childWidget: PropTypes.arrayOf(
      PropTypes.shape({
        slot: PropTypes.string.isRequired,
        widgetDefinitionIdentifier: PropTypes.string.isRequired,
        widgetSequence: PropTypes.number.isRequired,
        widgetProps: PropTypes.objectOf(
          PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        )
      })
    ).isRequired
  }).isRequired,
  espotData: PropTypes.objectOf(PropTypes.string),
  getEspotContent: PropTypes.func
};

export default memo(TemplateManager);
